import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./icon.html";
// List of custom utility icons we've implemented
const CUSTOM_UTILITY_ICONS = ['astro_agent'];
class C360Icon extends LightningElement {
  constructor(...args) {
    super(...args);
    this.iconDescription = void 0;
    this.iconClass = void 0;
    this._iconName = void 0;
    this._type = void 0;
    this._productIconName = void 0;
    this._privateSize = void 0;
    this._icon = void 0;
  }
  get iconName() {
    return this._iconName;
  }
  set iconName(iconName) {
    this._iconName = iconName;
    [this._type, this._icon] = iconName.split(':');
  }
  get size() {
    return this._privateSize ? this._privateSize : 'small';
  }
  set size(value) {
    this._privateSize = value;
  }
  get isProductType() {
    return this._type === 'product';
  }
  get isBootstrapperType() {
    return this._type === 'bootstrapper';
  }
  get isCustomUtilityType() {
    return this._type === 'utility' && CUSTOM_UTILITY_ICONS.includes(this._icon);
  }
  get isIconLibType() {
    return !this.isCustomUtilityType && (this._type === 'utility' || this._type === 'action' || this._type === 'standard');
  }
  get isIconTextType() {
    return this._type === 'text';
  }

  // utility:http is not included in lighting-base-components so this manually displays it
  get isUtilityHttp() {
    return this._type === 'utility' && this._icon === 'http';
  }
  get classesWithSizeForUtilityIcon() {
    return `slds-icon slds-icon-text-default slds-icon_${this.size}`;
  }
  get classesWithIconStyleForUtilityIcon() {
    return `slds-icon-utility-chevrondown slds-icon_container ${this.iconClass}`;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(C360Icon, {
  publicProps: {
    iconDescription: {
      config: 0
    },
    iconClass: {
      config: 0
    },
    iconName: {
      config: 3
    },
    size: {
      config: 3
    }
  },
  fields: ["_iconName", "_type", "_productIconName", "_privateSize", "_icon"]
});
const __lwc_component_class_internal = _registerComponent(C360Icon, {
  tmpl: _tmpl,
  sel: "c360-icon",
  apiVersion: 62
});
export default __lwc_component_class_internal;